module.exports = __webpack_public_path__ + "img/pijlkop-wit.274b9bf2067aa0129c28c925f8a0501e.svg";